<template>
	<div class="jobs-grid-wrapper">
        <v-data-table
			:headers="headers"
			:items="jobs"
			:rows-per-page-items="rowsPerPageItems"
			:total-items="pagination.totalItems"
			:pagination.sync="pagination"
			class="elevation-1 job-grid manage-jobs"
			v-model="selected">

			<template slot="items" slot-scope="props">
				<tr :class="(props.item.is_archived) ? 'archived' : ''" :active="props.selected" @click.prevent.stop="handleRowClick(props.item)">
					<td :class="['viewed-indicator', {unread: props.item.viewed_status === false}]"/>
					<td class="no-smoosh dept-text">{{ getJobEnumItemValue('jobDepartments', props.item.department, 'abbreviation') }}</td>
					<td class="no-smoosh">
						<v-menu
							class="options__menu"
							@click.native.stop>
							<v-btn
								icon
								slot="activator"
								class="text-xs-center">
								<v-icon
									:color="jobFlagColor(props.item.id)"
									size="22">
									{{ getFlagIcon(isJobFlagged(props.item.id)) }}
								</v-icon>
							</v-btn>

							<v-list dense>
								<v-list-tile
									class="menu-item">
									<v-list-tile-title>Tag Color</v-list-tile-title>
								</v-list-tile>
								<v-divider></v-divider>
								
								<v-list-tile
									class="menu-item"
									@click="setFlagged(props.item.id)">
									<v-list-tile-title>
										<v-icon>turned_in_not</v-icon> None
									</v-list-tile-title>
								</v-list-tile>

								<v-list-tile
									v-for="flag in jobFlags"
									:key="generateUniqueHash(flag)"
									class="menu-item"
									@click="setFlagged(props.item.id, flag)">
									<v-list-tile-title>
										<v-icon :color="flag.name.toLowerCase()">turned_in</v-icon> {{flag.name}}
									</v-list-tile-title>
								</v-list-tile>
							</v-list>

						</v-menu>
					</td>
					<td class="job-number job-number-text">{{ props.item.job_number }}</td>
					<td class="title">
						<a class="typography-text-btn title-text" :href="`/jobs/view/${props.item.id}/overview`" v-on:click.prevent.stop="$router.push({ name: 'job-overview', params: { jobId: props.item.id } })">{{ props.item.name }}</a>
						<span class="rush-item" v-if="checkRush(props.item.priority) || props.item.is_24_hour_rush">{{getJobPriority(props.item)}}</span>
					</td>
					<td class="no-smoosh date-col">{{ getJobEnumItemValue('jobTypes', props.item.type, 'name') }}</td>
                    <td class="no-smoosh date-col">{{ getJobEnumItemValue('jobStatuses', props.item.status, 'name')}}</td>
					<td class="no-smoosh date-col">{{ getJobEnumItemValue('jobProgresses', props.item.progress, 'name') }}</td>
					<!--<td class="no-smoosh date-col">{{ getJobEnumItemValue('jobProgresses', props.item.progress_note, 'name') }}</td>-->
					<td class="date-col" :style="[isLate(props.item.is_late)]">{{ props.item.date_submitted | f__twoDigitFullDate }}</td>
					<td class="date-col">{{ props.item.date_premedia | f__twoDigitFullDate }}</td>
					<td class="date-col">{{ props.item.date_first_comp | f__twoDigitFullDate }}</td>
					<td class="date-col">{{ props.item.date_release | f__twoDigitFullDate }}</td>
					<td class="date-col">{{ props.item.date_delivery | f__twoDigitFullDate }}</td>
					<td class="text-xs-center">
						<v-btn icon
							@click.prevent.stop="toggleJobWatch(props.item.id)">
							<v-icon
								:class="['watching-icon', (isJobWatched(props.item.id)) ? 'blue--text text--darken-4' : 'grey--text text--lighten-2']"
								size="22">
								visibility
							</v-icon>
						</v-btn>
					</td>
				</tr>
			</template>
            <template slot="no-data">
                <div class="view-global-loading" v-if="viewLoaded==false">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div class="view-global-nodata" v-else>No Results Found</div>
            </template>

		</v-data-table>

        <excel-export-link
            type="jobs"
        ></excel-export-link>

	</div>
</template>

<script>
	import { mapState, mapActions, mapGetters } from 'vuex'
    import Excel_Export_Link from '@/components/ui/_global/Excel_Export_Link.vue'

	import {
		VUEX_UI_SHOW_RIGHT_DRAWER } from '@/store/constants/ui'

	import {
		VUEX_JOB_GET_REQUEST,
		VUEX_JOBS_SYNC_PAGINATION,
		VUEX_JOB_WATCH,
		VUEX_JOB_UNWATCH,
		VUEX_JOB_FLAG,
		VUEX_JOB_UNFLAG,
		VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG,
	} from '@/store/constants/jobs'


	export default {
		name: 'jobs-center-grid',

        components: {
            'excel-export-link' : Excel_Export_Link
        },

		data:() => ({
			items:[],
			selected:[],
			headers: [
				{ text: null, value: 'viewed', sortable: false, class: 'viewed-indicator'},
				{ text: 'Dpt', value: 'department', sortable: true, class: 'no-smoosh' },
				{ text: 'Flag', value: 'flag', sortable: true, class: 'no-smoosh text-xs-center' },
				{ text: 'Job #', value: 'job_number', sortable: true, class: 'job-number' },
				{ text: 'Name', value: 'name', sortable: true, width: '100%' },
				{ text: 'Type', value: 'type', sortable: true, class: 'no-smoosh date-col' },
                { text: 'Status', value: 'status', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Progress', value: 'progress', sortable: true, class: 'no-smoosh date-col' },
				//{ text: 'note', value: 'progress_note', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Submit', value: 'dateCreated', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Premedia', value: 'date_premedia', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Comp', value: 'dateFirstComp', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Release', value: 'date_release', sortable: true, class: 'no-smoosh date-col' },
                { text: 'Deliver', value: 'dateDelivery', sortable: true, class: 'no-smoosh date-col' },
				{ text: 'Watch', value: 'watching', sortable: true, class: 'no-smoosh' },
			],
		}),

        beforeMount() {
            this.$store.dispatch('VUEX_JOBS_SET_APPROVED', { value: "true"})
        },

		computed: {
			...mapState({
				jobs: state => state.jobs.jobs,
                viewLoaded: state => state.jobs.jobsLoaded,
				jobsPagination: state => state.jobs.pagination,
				jobFlags: state => state.properties.jobFlags,
				watchedJobs: state => state.auth.currentUser.watched_jobs,
				flaggedJobs: state => state.auth.currentUser.flagged_jobs,
				rowsPerPageItems: state => state.properties.rowsPerPageItems,


				jobPendingComment: state => state.jobs.jobPendingComment,
				jobPendingCommentText: state => state.jobs.jobPendingCommentText,
				jobPendingCommentHasAttachments: state => state.jobs.jobPendingCommentHasAttachments,

				drawerOpenState: state => state.ui.rightDrawer.openState,
			}),

			...mapGetters({
				currentJobId: 'getJobId',
				isEditor: 'getAuthIsEditor',
				getJobEnumItemValue: 'getJobEnumItemValue'
			}),

			getJobPriority() {
				return (item) => {
					if (item.is_24_hour_rush) return '24Hr'

					let priority = this.getJobEnumItemValue('jobPriorities', item.priority, 'name')
					return (priority !== 'Standard' && priority !== 'Extended') ? priority : ''
				}
			},

			isLate() {
				return (prop) => {
					return prop ? 'color:red' : null
				}
			},

			pagination: {
				set(data) {
				    this.applySorting(data)
				},
				get() { return this.jobsPagination }
			},
            getItems() {
                return items
            }
		},

		watch: {
			'drawerOpenState': function (newValue, oldValue) {
				if (newValue === false) {
					if (this.$store.state.jobs.jobPendingCommentText || this.$store.state.jobs.jobPendingCommentHasAttachments) {
						this.$nextTick(function () {
							this.$store.dispatch(VUEX_UI_SHOW_RIGHT_DRAWER)
						})
					}
				}
			}
		},

		methods: {
			...mapActions({
				loadJob: VUEX_JOB_GET_REQUEST,
				showRightDrawer: VUEX_UI_SHOW_RIGHT_DRAWER,
				applySorting:VUEX_JOBS_SYNC_PAGINATION,
				watchJob: VUEX_JOB_WATCH,
				unwatchJob: VUEX_JOB_UNWATCH,
				setFlag: VUEX_JOB_FLAG,
				unsetFlag: VUEX_JOB_UNFLAG
			}),
			checkRush(priorityObject) {
				if (priorityObject === null) return false

				let abbr = this.getJobEnumItemValue('jobPriorities', priorityObject, 'abbreviation')
				if (abbr && abbr.toLowerCase() !== 'std') {
					return true
				}
			},

			handleRowClick: async function(jobObj) {
				// THIS FUNCTION IS IN A LOT OF PLACES, SEARCH FOR "IS_NOT_DRY" WHEN MAKING ANY CHANGE
				// TODO: Figure out how to trap in vuex
				// First, make sure we aren't in the middle of a comment. If we are
				// then confirm the navigation away, or not.
				if (this.$store.state.jobs.jobPendingCommentText || this.$store.state.jobs.jobPendingCommentHasAttachments) {
					// If we do have data in the store, ask to proceed.
					this.$store.dispatch(VUEX_UI_SHOW_RIGHT_DRAWER)

					let response = window.confirm('There is an unsaved comment. If you continue, you will lose the comment and any attachments you have made. Would you like to continue?')

					if (response) {
						// User wants to proceed, so teardown
						this.$store.commit(VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG)
					} else {
						// User wants to stay, so do not teardown
						return
					}
				} else {
					// If there is no data in the store, teardown so it is fresh on next load
					this.$store.commit(VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG)
				}

				// If we made it here, the user confirmed the row click.
				let jobId = jobObj.id
				this.selected = []
				this.selected.push(jobObj)

				if (jobId !== this.currentJobId) {
					await this.loadJob({ id: jobId, includeJobMeta: true })
				}
				this.showRightDrawer()
			},

			toggleJobWatch(jobId){
				let isWatched = this.isJobWatched(jobId)

				if (isWatched) {
					this.unwatchJob(jobId)
				} else {
					this.watchJob(jobId)
				}
			},

			isJobWatched(jobId) {
				let idx = this.watchedJobs.findIndex(x => x.job_id === jobId)
				return (idx > -1) ? true : false
			},

			setFlagged(jobId, flag=null) {
				if (flag) {
					this.setFlag({id:jobId, data:flag})
				} else {
					this.unsetFlag(jobId)
				}
			},

			// TODO: This is not ideal; put on user obj in vuex
			isJobFlagged(jobId) {
				let idx = this.flaggedJobs.findIndex(x => x.job_id === jobId)
				return (idx > -1) ? true : false
			},

			jobFlagColor(jobId) {
				let idx = this.flaggedJobs.findIndex(x => x.job_id === jobId)
				let color = 'grey'
				if (idx > -1) {
					let flag = this.jobFlags.findIndex(x => x.value === this.flaggedJobs[idx]['flag'])
					color = this.jobFlags[flag]['name'].toLowerCase()
				}
				return color
			},

			getFlagIcon(val) {
				return val ? 'turned_in' : 'turned_in_not'
			}
		},
	}
</script>
